import clsx from 'clsx';
import React from 'react';

import styles from './TwoColumnLayout.module.scss';

interface TwoColumnLayoutProp {
  left: React.ReactNode;
  right: React.ReactNode;
  className?: string;
}

export const TwoColumnLayout: React.FC<TwoColumnLayoutProp> = ({ left, right, className }) => (
  <div
    style={{ gridTemplateColumns: !right && '1fr' }}
    className={clsx(styles.container, className)}
  >
    <div
      id="left"
      className={styles.left}
    >
      {left}
    </div>
    {right && (
      <div
        id="right"
        className={styles.right}
      >
        {right}
      </div>
    )}
  </div>
);
